import React from "react";
import "./FormError.less";
import IntlMessages from "@util/IntlMessages";
import { Button } from "../../BP2Components";

const FormError = ({ customError = "", redirect = false }) => {
   return (
      <div className="form-error-wrapper p1">
         {customError ? (
            <div className="form-error-custom">
               <IntlMessages id={customError} />
               {redirect ? (
                  <Button buttonType="primary" style={{ width: "fit-content" }}>
                     <a href="/">
                        <IntlMessages id="formComplete.backToHomePage" />
                     </a>
                  </Button>
               ) : null}
            </div>
         ) : (
            <IntlMessages id="message.formLoadingError" />
         )}
      </div>
   );
};

export default FormError;
